import { render, staticRenderFns } from "./PageEditorToolbarPageBtn.vue?vue&type=template&id=411d9b16&scoped=true"
import script from "./PageEditorToolbarPageBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorToolbarPageBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411d9b16",
  null
  
)

export default component.exports